<template>
    <div class="headerwrap modulewrap">
        <div class="header realwrap">
            <div class="logo">
                <a href="https://shtraining.org.cn/">
                    <img :src="$store.state.config.imgdomain +'/upfile/36/images/logo.png'">
                </a>
            </div>
            <dl class="topnav" v-if="!$store.getters.issmall">
                <dd v-for="item in navlist" :key="item.id">
                    <a :href="item.url" :class="{cs:$store.state.topnav==item.kv}">{{item.title}}</a>
                </dd>
            </dl>


        </div>
    </div>
</template>

<script>
    export default {
        name: 'Cheader',
        data() {
            return {
                navlist: []
            };
        },
        computed: {
            topnavsort: function () {
                return this.$store.state.topnavsort;
            }
        },
        mounted() {

            this.$common.fetch({ 'act': 'sht_header', 'msg': '' }, res => {
                this.navlist = res.infodata;
            });

        }
    };
</script>
